@use "../../../../../../../src/styles/Colors.scss" as Colors;
@use "../../../../../../../src/styles/Constants.scss" as Constants;


.upload-icon,
.download-icon,
.preview-icon {
	width: 15px;
	font-size: 20px;
	transition: color 0.1s;
	cursor: pointer;
	color: Colors.$col-blue;
}


	